import type { FaireProductEntity } from "../../entity_types/product";

export const p_rmqhxjnj9c: FaireProductEntity = {
  token: "p_rmqhxjnj9c",
  type: "product",
  name: "Charlotte pave diamond ring ￼",
  brandToken: "b_pnfabwsu5v",
  brandName: "Glam Bar Bazaar",
  imageUrl:
    "https://cdn.faire.com/fastly/87477e1a2e0f83ba372a611b4f2f938854fb07c859600e807778460aabeb2d11.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8ee059a68f195b8aaa27212745d425b18f66c6373d63e555af7711a08cfc295f.jpeg",
  ],
  priceDollars: 34.8,
  description:
    "Indulge in sophistication and luxury with the Charlotte Pave Diamond Ring.\n\nCrafted with 925 sterling silver and expertly plated with 18 karat gold, this exquisite piece exudes timeless charm and elegance.\n\nKey Features:\n\n * 925 sterling silver construction for durability \n * 18 karat gold plating for a luxurious touch \n * Pave diamond detailing for a touch of sparkle \n * An exquisite piece that adds a touch of glamour to any outfit \n * An ideal accessory for both formal events and everyday wear \nElevate your style and make a statement with the Charlotte Pave Diamond Ring. Whether worn alone or stacked with other rings, this piece is sure to capture attention and become a treasured addition to your jewelry collection.\n",
  tags: [],
  msrpDollars: 58,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:44.894Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
